import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {isFunction} from "lodash";

function ScrollToTop()
{
    const location = useLocation();

    useLayoutEffect(() => {
        if(isFunction(document.documentElement.scrollTo)) {
            document.documentElement.scrollTo(0, 0);
        }
    }, [location.pathname]);

    return null;
}

export default ScrollToTop;
